module.exports = __webpack_public_path__ + "img/landing-page1.62d186a8.jpg";